// Mock Data for Gastroenterology Category

const baseProducts = [
    {
        id: "med-gastro-1",
        name: "Omeprazole 40mg",
        genericName: "Brand: Prilosec",
        indication: "Acid Reflux/GERD",
        price: "$12",
        originalPrice: "$150",
        savings: "92%",
        description: "A proton pump inhibitor (PPI) that decreases the amount of acid produced in the stomach. Used to treat acid reflux, GERD, and stomach ulcers.",
        dosage: "Typically taken once daily before a meal. Swallow whole.",
        packaging: "Contains 30 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture and heat.",
        sideEffects: "Headache, stomach pain, or mild diarrhea.",
        category: "Proton Pump Inhibitors"
    },
    {
        id: "med-gastro-2",
        name: "Mesalamine 1.2g",
        genericName: "Brand: Lialda",
        indication: "Ulcerative Colitis",
        price: "$50",
        originalPrice: "$550",
        savings: "90%",
        description: "An aminosalicylate anti-inflammatory drug used to treat mild to moderate ulcerative colitis and to help maintain remission.",
        dosage: "Taken orally, usually once daily with food. Do not chew or crush.",
        packaging: "Contains 120 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place.",
        sideEffects: "Nausea, stomach cramps, or mild headache.",
        category: "Aminosalicylates"
    },
    {
        id: "med-gastro-3",
        name: "Infliximab 100mg",
        genericName: "Brand: Remicade (Biosimilar)",
        indication: "Crohn's Disease, UC",
        price: "$1,080",
        originalPrice: "$5,600",
        savings: "80%",
        description: "A biologic medication (TNF blocker) given by IV infusion to treat severe Crohn's disease and ulcerative colitis when other medicines haven't worked.",
        dosage: "Administered via intravenous infusion under medical supervision.",
        packaging: "Contains 1 Vial for Reconstitution",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not freeze.",
        sideEffects: "Infusion reactions, increased risk of infections, or headache.",
        category: "Biologics"
    },
    {
        id: "med-gastro-4",
        name: "Vedolizumab 300mg",
        genericName: "Brand: Entyvio",
        indication: "Crohn's Disease, UC",
        price: "$1,440",
        originalPrice: "$6,800",
        savings: "78%",
        description: "A gut-selective biologic therapy used for adults with moderate to severe active ulcerative colitis or Crohn's disease.",
        dosage: "Administered as an IV infusion. Dosing schedule determined by physician.",
        packaging: "Contains 1 Vial",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated at 2°C to 8°C. Protect from light.",
        sideEffects: "Cold symptoms, headache, joint pain, or nausea.",
        category: "Biologics/Integrin Inhibitors"
    },
    {
        id: "med-gastro-5",
        name: "Ustekinumab 90mg",
        genericName: "Brand: Stelara",
        indication: "Crohn's Disease",
        price: "$1,980",
        originalPrice: "$8,500",
        savings: "76%",
        description: "A biologic medication that targets specific proteins (IL-12 and IL-23) involved in inflammation. Prescribed for moderate to severe Crohn's disease.",
        dosage: "Injected subcutaneously after an initial IV infusion dose.",
        packaging: "Contains 1 Pre-filled Syringe",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not shake.",
        sideEffects: "Vomiting, injection site redness/pain, or upper respiratory infections.",
        category: "Biologics/Interleukin Inhibitors"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-gastro-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Gastroenterology and GI Tract Management",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of inflammatory bowel diseases, severe acid reflux, and other gastrointestinal conditions. Sourced from WHO-GMP certified facilities.`,
            dosage: "Strictly as prescribed by your gastroenterologist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. Regular monitoring may be required for biologics.",
            category: "General Gastrointestinal Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const gastroenterologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const gastroenterologyHeroData = {
    title: "Gastroenterology",
    subtitle: "Digestive disorders, IBD, and gastrointestinal medications",
    description: "Access high-quality, authentic medications for the management of Crohn's disease, Ulcerative Colitis, severe GERD, and other digestive disorders. We supply highly effective biologics and generics worldwide.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "80%", label: "Average Savings" }
    ]
};

export const gastroenterologyCategories = [
    "All Categories",
    "Biologics",
    "Biologics/Integrin Inhibitors",
    "Proton Pump Inhibitors",
    "Aminosalicylates",
    "General Gastrointestinal Care"
];

export const gastroenterologyTrustBadges = [
    { text: "WHO-GMP Certified Sources", icon: "ShieldCheck" },
    { text: "Cold-Chain Logistics", icon: "Thermometer" },
    { text: "Verified Pharmacists", icon: "Users" },
    { text: "Quality Assured", icon: "Award" }
];

export const gastroenterologyFAQs = [
    {
        question: "Do you require a prescription for specialty GI biologics?",
        answer: "Yes. All specialty gastroenterology medications, especially biologics and immunosuppressants, require a valid prescription from a licensed gastroenterologist."
    },
    {
        question: "How do you ship temperature-sensitive medications like Infliximab?",
        answer: "We use specialized cold-chain logistics. Biologics and temperature-sensitive medications are shipped in validated, temperature-controlled packaging with data loggers to maintain 2°C to 8°C throughout transit."
    },
    {
        question: "Are generic GI medications as effective as the brand-name versions?",
        answer: "Yes. The generics and biosimilars we supply undergo rigorous testing and are approved as bioequivalent, ensuring the exact same clinical results as the brand names."
    },
    {
        question: "Can I coordinate complex multi-drug regimens for IBD?",
        answer: "Absolutely. Our expert pharmacy team can help consolidate your varied prescriptions, offering bulk discounts and ensuring you have everything you need in one shipment."
    }
];

export const gastroenterologyTestimonials = [
    {
        name: "Michael S.",
        country: "United States",
        savings: "$54,000 annually",
        condition: "Crohn's Disease",
        medication: "Vedolizumab (Entyvio Generic)",
        text: "The cost of biologic infusions out of pocket was impossible for me. MediSeller provided a reliable source for my medication, saving my health and my finances."
    },
    {
        name: "Angela R.",
        country: "Australia",
        savings: "$6,000 annually",
        condition: "Ulcerative Colitis",
        medication: "Mesalamine",
        text: "Getting Lialda locally was incredibly expensive. I switched to the generic provided here and my symptoms represent a perfect state of remission. Fast shipping too."
    },
    {
        name: "David T.",
        country: "United Kingdom",
        savings: "$8,500 annually",
        condition: "Severe GERD",
        medication: "Omeprazole & Supplements",
        text: "While Omeprazole is accessible everywhere, the bulk deals and quality I receive from this pharmacy, alongside excellent customer care, keep me coming back."
    }
];

export const gastroenterologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Read how patients successfully manage chronic digestive and bowel disorders using our pharmacy network."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information regarding the safe ordering of gastroenterology medications and biologics."
    },
    midPageCTA: {
        title: "Seeking a Specific GI Treatment?",
        description: "Our procurement team can source a wide range of aminosalicylates, corticosteroids, and specialized biologics globally at significant discounts.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Medicine Price"
    },
    finalCTA: {
        title: "Take Control of Your Digestive Health",
        description: "Don't compromise your treatment due to high specialty medication costs. Secure your reliable GI supply today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
